import {useRuntimeEnvironment} from '@github-ui/ssr-utils/use-runtime-environment'
import {isStaff} from '@github-ui/stats'
import {CommentIcon} from '@primer/octicons-react'
import {Label, NavList, Tooltip} from '@primer/react'

const PUBLIC_FEEDBACK_URL = 'https://gh.io/issues-sidebar-feedback'
const STAFF_FEEDBACK_URL = 'https://gh.io/issues-sidebar-feedback-staff'

/** Util for preventing hydration issues when SSR'ing to capture the correct feedback link */
export function useFeedbackLink() {
  // The staff header is only available during CSR
  const {isBrowser} = useRuntimeEnvironment()
  return isBrowser && isStaff() ? STAFF_FEEDBACK_URL : PUBLIC_FEEDBACK_URL
}

/**
 * Feedback link for the collapsible sidebar footer. Shows a tooltip in
 * condensed mode and a "Preview" badge when expanded.
 */
export function CollapsibleFeedbackLink({isExpanded}: {isExpanded: boolean}) {
  const feedbackUrl = useFeedbackLink()

  return (
    <NavList aria-label="Feedback">
      <Tooltip text="Feedback" direction="e" _privateDisableTooltip={isExpanded}>
        <NavList.Item href={feedbackUrl} target="_blank" rel="noopener noreferrer">
          <NavList.LeadingVisual>
            <CommentIcon />
          </NavList.LeadingVisual>
          Feedback
          {isExpanded && (
            <NavList.TrailingVisual>
              <Label variant="success">Preview</Label>
            </NavList.TrailingVisual>
          )}
        </NavList.Item>
      </Tooltip>
    </NavList>
  )
}
